import { ISiteSAMLConfiguration } from '../types/ISiteSAMLConfiguration';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface ISetSiteSAMLEnabledParams {
  enable: boolean;
}

export class SetSiteSAMLEnabledRequest extends Request<ISetSiteSAMLEnabledParams, ISiteSAMLConfiguration> {
  constructor(params: ISetSiteSAMLEnabledParams) {
    super('setSiteSAMLEnabled', params);
  }
}
